import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { setDefaultOptions } from 'date-fns';

import { getDateFnsLocale } from './date-fns-locale';

@Injectable()
export class DateFnsLocaleService {
  private translate = inject(TranslateService);

  constructor() {
    this.syncLocale(this.currentLang());
    this.translate.onLangChange.subscribe((event) => {
      this.syncLocale(event.lang);
    });
  }

  private currentLang(): string {
    return this.translate.currentLang || this.translate.defaultLang || 'hu';
  }

  private syncLocale(lang: string): void {
    setDefaultOptions({ locale: getDateFnsLocale(lang) });
  }
}
